/**
 * iOS-Zoom in fremden Formularen verhindern.
 *
 * iOS Safari zoomt die Seite hinein, sobald ein Eingabefeld mit weniger als
 * 16px Schrift den Fokus bekommt, und zoomt danach nicht von selbst zurueck.
 * Der Kunde sitzt dann auf einer vergroesserten Seite fest und sieht die
 * rechte Haelfte nicht mehr.
 *
 * Fuer die Felder des Themes erledigt das eine CSS-Regel in base.css. Das
 * Newsletter-Formular stammt aber von der App "Forms" (Shopify Forms) und
 * liegt in einem eigenen Shadow DOM (<shopify-forms-embed>). CSS-Selektoren
 * aus dem Theme reichen dort nicht hinein, gemessen wurden 14px. Der Shadow
 * Root ist jedoch offen, also laesst sich die Regel hineinlegen.
 *
 * Geprueft am 15.09.2026: Feld 14px -> 16px.
 */
(function () {
  'use strict';

  var REGEL =
    '@media screen and (max-width: 749px){' +
    'input:not([type=checkbox]):not([type=radio]):not([type=range]):not([type=file]):not([type=submit]):not([type=button]),' +
    'select,textarea{font-size:max(16px,1em) !important}}';
  var MARKE = 'data-stoffeya-ios-zoom';

  function einlegen(root) {
    if (!root || root.querySelector('style[' + MARKE + ']')) return;
    var stil = document.createElement('style');
    stil.setAttribute(MARKE, '');
    stil.textContent = REGEL;
    root.appendChild(stil);
  }

  // Nur eigene Elemente (Bindestrich im Namen) koennen einen Shadow Root
  // tragen; das haelt den Durchlauf kurz.
  function durchgang() {
    var alle = document.getElementsByTagName('*');
    for (var i = 0; i < alle.length; i++) {
      var el = alle[i];
      if (el.tagName.indexOf('-') !== -1 && el.shadowRoot) einlegen(el.shadowRoot);
    }
  }

  function start() {
    durchgang();

    // Das Formular erscheint erst nach einigen Sekunden, und die App haengt
    // ihren Shadow Root teils nach dem Einfuegen an. Beides faengt ein paar
    // spaetere Durchgaenge ab, danach genuegt der Beobachter.
    [500, 1500, 3000, 6000, 12000, 25000].forEach(function (ms) {
      window.setTimeout(durchgang, ms);
    });

    var geplant = false;
    new MutationObserver(function () {
      if (geplant) return;
      geplant = true;
      window.requestAnimationFrame(function () {
        geplant = false;
        durchgang();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
